import { Link, Typography, Box } from "@mui/material";
import { CoreCheckbox, CoreInfoIndicator, VerityColorLogo } from "../../core";
import ThemeWrapper from "../../theme";
import { Trans } from "react-i18next";
import i18nPackage from "../../i18n/i18n";

export type ThirdPartyCheckboxErrorReason = "auth" | "noExtension";

type CheckboxErrorProps = {
	verityEnabled: boolean;
	error: ThirdPartyCheckboxErrorReason;
};

export default function CheckboxError({ verityEnabled, error }: CheckboxErrorProps) {
	const translationKey = error === "auth" ? "auth" : "noExtension";

	const commonTextStyle = {
		color: "#273540",
		fontSize: "14px",
		lineHeight: 1.6,
		fontWeight: 400,
	};

	return (
		<ThemeWrapper scoped={false}>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					gap: "10px",
					backgroundColor: "#fbfaff",
					alignItems: "flex-start",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						gap: "10px",
						width: "100%",
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							gap: "10px",
							alignItems: "center",
						}}
					>
						<CoreCheckbox checked={verityEnabled} disabled />

						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								gap: "5px",
								alignItems: "center",
								"& p, & label": commonTextStyle,
							}}
						>
							<VerityColorLogo height={20} width={20} />
							<Typography>{i18nPackage.t("interceptStrategy.checkboxError.thirdPartyTitle")}</Typography>
						</Box>
					</Box>

					<Box sx={{ height: 20, width: 20 }}>
						<CoreInfoIndicator hint={i18nPackage.t("interceptStrategy.checkboxError.thirdPartyTooltip")} size={20} />
					</Box>
				</Box>

				<Typography
					sx={{
						...commonTextStyle,
						paddingLeft: "33px",
						paddingRight: "5px",
					}}
				>
					<Trans
						i18n={i18nPackage}
						i18nKey={`interceptStrategy.checkboxError.error.${translationKey}`}
						components={{
							a: (
								<Link
									href="https://chromewebstore.google.com/detail/yuja-verity-chrome-extens/behjakjklighlhiefaoogbalmenhbjid"
									target="_blank"
									rel="noreferrer"
									aria-label={i18nPackage.t("interceptStrategy.checkboxError.openNewLinkAriaLabel")}
								/>
							),
						}}
					/>
				</Typography>
			</Box>
		</ThemeWrapper>
	);
}
